import React from 'react'
import styled from 'styled-components'
import Container from './Container'
import TypedTitle from './TypedTitle'
import Navigation from './Navigation'

const App = () => {
  return (
    <Container>
      <Content>
        <TypedContainer>
          <TypedTitle />
        </TypedContainer>
        <Navigation />
      </Content>
    </Container>
  )
}

const TypedContainer = styled.div`
  transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  width: auto;
  text-align: center;
  border-radius: 5px;

  &:hover {
    background: #fbff12;
    padding: 50px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 100px;
  height: 90%;
`

export default App
